var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduateHatShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.88 41.79v0a19.76 19.76 0 0 1-15.88-19.37v-6.42a10 10 0 0 1 10-10h16a10 10 0 0 1 10 10v6.42c0 9.41-6.65 17.52-15.88 19.37h0c-1.4.28-2.84.28-4.24 0v0Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.91v5.2a3 3 0 0 0 1.66 2.68l1.16.58a6 6 0 0 0 5.36 0l1.16-.58a3 3 0 0 0 1.66-2.69v-5.19",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.14 21.3 6.7 3.21a5 5 0 0 0 4.32 0l6.7-3.2a2 2 0 0 0 0-3.61l-6.7-3.21a5 5 0 0 0-4.32 0l-6.7 3.2a2 2 0 0 0 0 3.61Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 19.49v4.51",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduateHatShield);
export default __webpack_public_path__ + "static/media/graduate-hat-shield.12f7169a1a6922a657be3ebe63ea3cf5.svg";
export { ForwardRef as ReactComponent };